export {
  default 
} from "./linkButton";
